export default __webpack_public_path__ + "static/mobile-ppq-modal-images-5e82f1eba70cde85f3edc20de677570f.png";